/* eslint-disable no-return-assign */
import React from 'react';
import Slider from 'react-slick';
import PropTypes from 'prop-types';
import Image from 'components/Image';
import { bindGa } from 'helpers/analytics';
import decodeHtml from 'utils/htmlDecoder';
//import { FacebookShareButton } from 'react-share';
import s from './Slideshow.scss';
// eslint-disable-next-line no-unused-vars
import slickcss from '../../../../../../node_modules/slick-carousel/slick/slick.css';

class Slideshow extends React.PureComponent {
  constructor() {
    super();
    this.state = {
      nav1: null,
      nav2: null,
      initialSlide: 0,
      showCaptions: false,
      fullView: false,
      shareUrl: '',
    };
  }
  componentDidMount() {
    this.setState({
      nav1: this.slider1,
      nav2: this.slider2,
      // initialSlide,
    });

    const countElem = document.getElementById(
      `slideshow-count-${this.props.msid}`,
    );

    this.countElem = countElem;

    if (
      !this.props.isWapView &&
      this.props.query &&
      this.props.query.slideshow &&
      this.props.query.slideshow === this.props.msid &&
      this.props.query.slide
    ) {
      const { slides } = this.props;
      for (let i = 0; i < slides.length; i += 1) {
        if (slides[i].msid === this.props.query.slide) {
          this.slider1.slickGoTo(i);
          break;
        }
      }
    }
  }

  onBeforeChange = (oldIndex, newIndex) => {
    if (this.countElem) {
      this.countElem.innerHTML = newIndex + 1;
    }
  };

  onAfterChange = newIndex => {
    let shareUrl = '';
    if (!this.props.isWapView && !this.props.nicView) {
      const { slides } = this.props;
      shareUrl = `${this.props.wu}?slideshow=${this.props.msid}&slide=${
        slides[newIndex].msid
      }#${newIndex + 1}`;
      window.history.pushState({}, '', shareUrl);
    }
    this.setState({ initialSlide: newIndex, shareUrl });
  };

  @bindGa({})
  toggleCaption() {
    this.setState({ showCaptions: !this.state.showCaptions });
  }

  toggleFullScreen = () => {
    this.setState({ fullView: !this.state.fullView });
  };

  @bindGa({})
  shareOnTwitter() {
    const { title, wu } = this.props;
    let twitterShareUrl = 'https://twitter.com/intent/tweet?';
    twitterShareUrl += encodeURI(
      `text=${title}&url=${this.state.shareUrl || wu}`,
    );
    window.open(twitterShareUrl, '_blank', 'width=450,height=450');
  }

  @bindGa({})
  shareOnFb() {
    const url = this.state.shareUrl || this.props.wu;
    let fbShareUrl = 'https://www.facebook.com/sharer/sharer.php?';
    fbShareUrl += encodeURI(`u=${url}`);
    window.open(fbShareUrl, '_blank', 'width=450,height=450');
  }

  render() {
    const settings = {
      slidesToShow: 1,
      slidesToScroll: 1,
      pauseOnHover: false,
      pauseOnFocus: false,
      dots: false,
      arrows: true,
      swipeToSlide: true,
      autoplay: false,
      draggable: false,
      initialSlide: this.state.initialSlide,
      infinite: false,
      beforeChange: this.onBeforeChange,
      afterChange: this.onAfterChange,
    };
    const settings1 = {
      slidesToShow: 1,
      slidesToScroll: 1,
      pauseOnHover: false,
      pauseOnFocus: false,
      dots: false,
      arrows: false,
      swipeToSlide: true,
      autoplay: false,
      draggable: false,
      initialSlide: this.state.initialSlide,
      infinite: false,
    };
    const { slides } = this.props;
    const containerId = `slideshow-count-${this.props.msid}`;
    if (!slides || slides.length === 0) {
      return null;
    }
    const gaCategory = 'slideshow';
    const gaLabel = `msid_${this.props.msid}-slideshow`;
    let captionTxt;
    let gaActionForCaption;
    if (!this.state.showCaptions) {
      captionTxt = 'Show Captions';
      gaActionForCaption = 'inline-caption-show';
    } else {
      captionTxt = 'Hide Captions';
      gaActionForCaption = 'inline-caption-hide';
    }

    return (
      <div
        data-slideshow={this.props.msid}
        className={`${s.slideshow_wrapper} as_inlineslideshow ${
          this.state.fullView ? `${s.showfullview} showfullview` : ''
        }`}
      >
        <div className={s.slider_headingwrapper}>
          <div className={s.slideshow_count}>
            <span id={containerId}>1</span>/{slides.length}
          </div>
          {this.props.isWapView ? (
            <div
              className={`${s.slideshow_fullscreen}`}
              onClick={() => this.toggleFullScreen()}
            />
          ) : (
            ''
          )}
          <h3>{this.props.title}</h3>
        </div>
        <Slider
          {...settings}
          asNavFor={this.state.nav2}
          ref={slider => (this.slider1 = slider)}
        >
          {slides &&
            slides.length &&
            slides.map(value => (
              <div className={s.slideimg_container} key={value.msid}>
                <div className={s.sliderimg_wrapper}>
                  <Image
                    alt={value.title}
                    src={`https://static.toiimg.com/photo/${value.msid}.cms`}
                  />
                </div>
              </div>
            ))}
        </Slider>
        {!this.props.isWapView &&
          !this.props.nicView && (
            <div className={s.slideshow_sharing}>
              <div
                className={s.fb}
                data-ga={`${gaCategory}-inline-share-facebook|${gaLabel}`}
                onClick={e => this.shareOnFb(e)}
              />
              <div
                className={s.twit}
                data-ga={`${gaCategory}-inline-share-twitter|${gaLabel}`}
                onClick={e => this.shareOnTwitter(e)}
              />
            </div>
          )}
        <div
          className={`${s.slideshow_caption} ${
            this.state.showCaptions ? s.hide : ''
          }`}
        >
          <div
            className={s.captiontxt}
            data-ga={`${gaCategory}-${gaActionForCaption}|${gaLabel}`}
            onClick={e => this.toggleCaption(e)}
          >
            {captionTxt}
          </div>
          <Slider
            {...settings1}
            asNavFor={this.state.nav1}
            ref={slider => (this.slider2 = slider)}
            className={s.slideshowdetails}
          >
            {slides &&
              slides.length &&
              slides.map(value => (
                <div
                  className={s.slideshowdetails}
                  key={value.msid}
                  dangerouslySetInnerHTML={{ __html: decodeHtml(value.cap) }}
                />
              ))}
          </Slider>
        </div>
      </div>
    );
  }
}

Slideshow.propTypes = {
  isWapView: PropTypes.bool,
  title: PropTypes.string.isRequired,
  wu: PropTypes.string.isRequired,
  nicView: PropTypes.bool,
};

Slideshow.defaultProps = {
  isWapView: false,
  nicView: false,
};

export default Slideshow;
